import { tsValidateBoolean, tsValidateEmail, tsValidateString, tsValidateValue, tsValidator_nonMandatoryString } from '@nu-art/ts-common';
import { _accountTypes } from './types.js';
import { accountGroupName } from '../session/consts.js';
const modifiablePropsValidator = {
    email: tsValidateEmail,
    type: tsValidateValue(_accountTypes),
    thumbnail: tsValidateString(undefined, false),
    displayName: tsValidateString(undefined, false),
    description: tsValidateString(undefined, false)
};
const generatedPropsValidator = {
    _auditorId: tsValidateString(),
    _newPasswordRequired: tsValidateBoolean(false),
    salt: tsValidator_nonMandatoryString,
    saltedPassword: tsValidator_nonMandatoryString,
};
export const DBDef_Accounts = {
    dbKey: 'user-account--accounts',
    entityName: 'Account',
    modifiablePropsValidator: modifiablePropsValidator,
    generatedPropsValidator: generatedPropsValidator,
    versions: ['1.0.0'],
    frontend: {
        group: accountGroupName,
        name: 'account'
    },
    backend: {
        name: 'user-account--accounts',
    }
};
//# sourceMappingURL=db-def.js.map